import React from 'react'
import { noop } from 'utils'

import Grid from '@mui/material/Grid'
import Switch from '@mui/material/Switch'

export interface ToggleButtonProps {
  checked?: boolean
  disabled?: boolean
  labelOff?: string
  labelOn?: string
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined
}

function ToggleButton({ checked = false, disabled = false, labelOff = '', labelOn = '', onChange = noop }: ToggleButtonProps) {
  return (
    <Grid alignItems="center" component="label" container justifyContent="center">
      <Grid item>{labelOff}</Grid>
      <Grid item>
        <Switch color="default" checked={checked} disabled={disabled} onChange={onChange} />
      </Grid>
      <Grid item>{labelOn}</Grid>
    </Grid>
  )
}

export default ToggleButton
